module.exports = __webpack_public_path__ + "img/rangeLabel.04f9e67c.svg";